import axios from 'axios'

export default {
    checkResponse (response) {
        if (response) {
            if (!!response.data.deactivated) {
                if (window.location.pathname != '/login') {
                    return window.location.href = '/login'
                }
            } else {
                return response.data
            }
        } else {
            toastr['error']('Ошибка', 'Ошибка')

            return window.location.href = '/login'
        }
    },
    getLogs (page, sort, isAllPages, pageSize) {
        let url = '/logs/list?page=' + page + '&sortBy=' + sort.sortBy + '&sortDesc=' + sort.sortDesc + '&allPages=' + isAllPages + '&pageSize=' + pageSize;

        return axios.get(url)
            .then(response => {

                return this.checkResponse(response)
            })
    },
    getLog (id) {
        return axios.get('/logs/get/' + id)
            .then(response => {

                return this.checkResponse(response)
            })
    }
}



// WEBPACK FOOTER //
// ./resources/js/services/logsDataService.js